import { styled } from '@ghq-abi/design-system';

type InnerContentProps = {
  primaryValue?: string | number;
  secondaryValue?: string | number;
  isPrinting?: boolean;
};

const Container = styled('div', {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

const PrimaryText = styled('p', {
  textAlign: 'center',
  fontWeight: 'bold',
  color: '#1a1a1a',
  fontSize: '20px',
  margin: 0,
  variants: {
    isPrinting: {
      true: {
        margin: 0,
        fontSize: '16px',
      },
    },
  },
});

const SecondaryText = styled('p', {
  textAlign: 'center',
  color: '#9ca3af',
  fontSize: '14px',
  variants: {
    isPrinting: {
      true: {
        margin: 0,
        fontSize: '12px',
      },
    },
  },
});

export const InnerContent: React.FC<Readonly<InnerContentProps>> = ({
  primaryValue,
  secondaryValue,
  isPrinting,
}) => {
  return (
    <Container>
      <PrimaryText isPrinting={isPrinting}>{primaryValue}</PrimaryText>
      <SecondaryText isPrinting={isPrinting}>{secondaryValue}</SecondaryText>
    </Container>
  );
};
